import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

class LearnSourceService {
  static getLearnSources(limit = 100, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE}?pageSize=${limit}&page=${page}`)
  }

  static getLearnSource(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE}/${id}`)
  }

  static addLearnSource(learnSource) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE}`, {
      method: 'POST',
      body: JSON.stringify({
        learnSource
      })
    })
  }

  static updateLearnSource(learnSource) {
    if (typeof learnSource._id === 'undefined') {
      return this.addLearnSource(learnSource)
    }

    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE}/${learnSource['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        learnSource
      })
    })
  }

  static deleteLearnSource(id) {
    return ApiHelper.fetch(`${API.URL + API.LEARN_SOURCE}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default LearnSourceService
